import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { message } from "antd";

const ApplicationIgnore = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const declineInterview = async () => {
      try {
        const response = await axios.get(`/recruitment/interviews/${id}/decline`);
        message.success(response.data.message || "Interview declined successfully");
        setTimeout(() => {}, 2000);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to decline interview");
        message.error(err.response?.data?.message || "Failed to decline interview");
      } finally {
        setLoading(false);
      }
    };

    declineInterview();
  }, [id]);

  return (
    <section className="quixoticVellumFrame">
      <div className="nebularCardinalBox">
        <h2>Interview Declined</h2>
        {loading && (
          <div className="zephyrPulseVortex">
            <div className="luminousProgressArc">
              <div className="arcaneProgressWave"></div>
            </div>
            <p className="etherealStatusNote">Processing...</p>
          </div>
        )}
        {error && (
          <div className="crimsonAlertBeacon">
            <p>{error}</p>
          </div>
        )}
        {!loading && !error && (
          <div className="verdantSuccessGlimmer">
            <p>You have declined the interview.</p>
          </div>
        )}
        <div className="crypticSupportWhisper">
          <p>Need assistance? Contact our support team.</p>
        </div>
      </div>
    </section>
  );
};

export default ApplicationIgnore;